module.exports = __webpack_public_path__ + "static/media/np.ae77ebf5.svg";